import { render, staticRenderFns } from "./CorreoDetalle.vue?vue&type=template&id=7c063dd0&"
import script from "./CorreoDetalle.vue?vue&type=script&lang=js&"
export * from "./CorreoDetalle.vue?vue&type=script&lang=js&"
import style0 from "./CorreoDetalle.vue?vue&type=style&index=0&id=7c063dd0&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports